"use client"
import { Stethoscope, CheckCircle2, AlertCircle } from "lucide-react";
import { getProbabilityColor } from "./utils";

export default function DifferentialDiagnosis({ differentialDiagnosis }) {
    if (!differentialDiagnosis || differentialDiagnosis.length === 0) return null;

    return (
        <div className="pt-2">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                <Stethoscope className="w-4 h-4 sm:w-5 sm:h-5 text-[#0B7BC1] flex-shrink-0" />
                Differential Diagnosis
            </h3>
            <div className="space-y-3 sm:space-y-4">
                {differentialDiagnosis.map((dx, index) => (
                    <div key={index} className="p-3 sm:p-4 bg-gray-50 border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-3">
                            <div className="flex items-center gap-3">
                                <span className="flex-shrink-0 w-7 h-7 bg-[#0B7BC1] text-white rounded-full flex items-center justify-center text-sm font-bold">
                                    {dx.rank || index + 1}
                                </span>
                                <div>
                                    <h4 className="text-base font-semibold text-gray-900">{dx.diagnosis}</h4>
                                    {dx.icd10_code && (
                                        <span className="text-xs text-gray-500 font-mono">ICD-10: {dx.icd10_code}</span>
                                    )}
                                </div>
                            </div>
                            {dx.probability && (
                                <span className={`text-xs font-medium px-3 py-1 rounded-full border ${getProbabilityColor(dx.probability)}`}>
                                    {dx.probability} probability
                                </span>
                            )}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 sm:gap-3">
                            {dx.supporting_evidence && dx.supporting_evidence.length > 0 && (
                                <div className="p-2 sm:p-3 bg-green-50 border border-green-200 rounded-md">
                                    <p className="text-xs font-semibold text-green-900 mb-1 sm:mb-1.5 flex items-center gap-1">
                                        <CheckCircle2 className="w-3 h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0" />
                                        Supporting Evidence
                                    </p>
                                    <ul className="space-y-1">
                                        {dx.supporting_evidence.map((ev, i) => (
                                            <li key={i} className="text-xs text-green-800 flex gap-1.5">
                                                <span className="text-green-400 mt-0.5 flex-shrink-0">•</span>
                                                <span className="break-words">{ev}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            {dx.against_evidence && dx.against_evidence.length > 0 && (
                                <div className="p-2 sm:p-3 bg-red-50 border border-red-200 rounded-md">
                                    <p className="text-xs font-semibold text-red-900 mb-1 sm:mb-1.5 flex items-center gap-1">
                                        <AlertCircle className="w-3 h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0" />
                                        Against Evidence
                                    </p>
                                    <ul className="space-y-1">
                                        {dx.against_evidence.map((ev, i) => (
                                            <li key={i} className="text-xs text-red-800 flex gap-1.5">
                                                <span className="text-red-400 mt-0.5 flex-shrink-0">•</span>
                                                <span className="break-words">{ev}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
